import { CONFIG } from '@gallaghercp/core-frontend';

export const APP_CONFIG: CONFIG = {
    appName: 'Disney Travel Assistance',
    frontend: 'https://travelassistance.disneytech.com',
    apiHash: 'https://travelassistance.disneytech.com/api/1.0',
    api: '/api/2.0',
    trustModel: false,
    authHeaders: {
        xServiceProvider: 'disneytwdc-prod-frontend',
        'tenant-id': '060457d9-4c8d-4078-b37c-ed3293d74566',
        'consumer-id': 'b9b0f3fa-61d9-4c6b-943a-39ebe3fb7815',
    },
    commitSHA: '4512443',
    provider: 'disneytwdc-prod-frontend',
    gtm: 'GTM-WP93HG96',
showNotifications: false,
    multilingual: false,
    colors: {
        primary: '#040714',
        secondary: '#02D6E8',
    },
    readabilityEnabled: false,
    articlesParentRoute: 'news',
    copyright: '&copy; ' + new Date().getFullYear() + ' Gallagher. All Rights Reserved.' + ' Powered by Core.',
    demoMode: false,
    chatEnabled: false,
    contactEnabled: false,
    isDarkModeEnabled: false,
    postsLabel: 'news',
    coreLinkify: true,
    navigation: {
        navType: 'top',
        headerStyle: 'solid',
        style: 'default',
        categoryNav: false,
        navigationOrder: 'displayOrder',
    },
    pwa: {
        enabled: false,
        notifications: false,
    },
    enableSSR: false,
    cookiePolicy: '2d696fd7',
} as CONFIG; 
